<template>
  <div class="modal fade show" style="display:block">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-light p-3">
          <h5 class="modal-title">{{this.$t('page.expert-system.ExpertStatement')}}</h5>
          <button type="button" class="btn-close" @click="handleClose"></button>
        </div>
        <form>
          <div class="modal-body">
            <div class="row gy-4 mb-3">
              <div class="col-12">
                <label for="name-field" class="form-label">{{this.$t('page.event-management.FaultCauseAnalysisSuggestions')}}</label>
                <textarea rows="3" class="form-control" v-model="form.suggestion"/>
              </div>
            </div>
            <div class="row gy-4 mb-3">
              <div class="col-12">
                <label for="name-field" class="form-label">{{this.$t('page.expert-system.ProcessDescription')}}</label>
                <textarea rows="3" class="form-control" v-model="form.instruction" />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="hstack gap-2 justify-content-end">
              <button type="button" class="btn btn-light" @click="handleClose">
                {{this.$t('base.cancel')}}
              </button>
              <button type="button" class="btn btn-primary" @click="handleSubmit">
                {{this.$t('base.update')}}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show"></div>
</template>
<script>

import _ from "loadsh"

export default {
  emits: ['update:isShowExpertExplain',"handleMeasureExpertSugg"],
  props:{
    isShowExpertExplain:Boolean,
    singleData:{
      type:Object,
      default:()=>{
        return {}
      }
    }
  },
  data(){
    return{
      form:{},
    }
  },
  watch:{
    // singleData:{
    //   handler(newVal){
    //     this.form = _.cloneDeep(newVal)
    //   },
    //   deep:true,
    //   immediate:true
    // }
  },
  mounted(){
    this.form = _.cloneDeep(this.singleData)
  },
  computed:{},
  methods:{
    handleClose(){
      this.$emit("update:isShowExpertExplain",false);
    },
    handleSubmit(){
      this.$emit("handleMeasureExpertSugg",this.form)
    }
  }
}
</script>